import React from "react";

import ButtonGroup from "components/v2/ButtonGroup/ButtonGroup";

type ButtonGroupFilterProps = {
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
  options: any;
};

function ButtonGroupFilter(props: ButtonGroupFilterProps) {
  const { currentFilters, setFilters, filterKey, options = [] } = props;

  const handleButtonClick = (value: any) => {
    setFilters((prevFilters: any) => {
      const currentValues = prevFilters[filterKey] || [];
      const valueIndex = currentValues.indexOf(value);
      if (valueIndex >= 0) {
        return {
          ...prevFilters,
          [filterKey]: currentValues.filter((item: any) => item !== value),
        };
      }
      return {
        ...prevFilters,
        [filterKey]: [...currentValues, value],
      };
    });
  };

  return (
    <div className="w-100">
      <ButtonGroup
        fullWidth
        buttons={options.map((option: any) => ({
          label: option.label,
          value: option.value,
          isActive: (currentFilters[filterKey] || []).includes(option.value),
          onClick: () => handleButtonClick(option.value),
        }))}
      />
    </div>
  );
}

export default ButtonGroupFilter;
